import React, { Component } from "react";
import "./App.css";
import { Link, Redirect, useHistory, useLocation } from "react-router-dom";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import QrReader from "react-qr-scanner";
import Footer from "./components/Footer";
import {
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoLogoAndroid,
  IoLogoWindows,
  IoLogoChrome,
  IoLogoApple,
  IoIosBrowsers,
  IoIosSettings,
  IoIosArrowBack,
} from "react-icons/io";
import { BiEditAlt } from "react-icons/bi";
import { AiOutlineScan } from "react-icons/ai";
import { RiCalendarEventLine } from "react-icons/ri";
import { FaEdge, FaSafari, FaFirefox, FaLinux } from "react-icons/fa";

import Header_ from "./components/HeaderCampaign";
import Switch from "react-switch";
// import HorizontalScroller from "react-horizontal-scroll-container";
import TopBarProgress from "react-topbar-progress-indicator";
import { Col, Container, Row } from "react-bootstrap";
import RefundRules from "./components/refunds/RefundRules";
import RefundRequests from "./components/refunds/RefundRequests";
import Header3 from "./components/Header3";
import Header from "./layouts/Header";

// const { state } = this.props.location || {};
// const event_id = state?.eventid;
const RefundView = () => {
  const history = useHistory();
  const location = useLocation();
  const { eventid, eventname, is_sponsorship } = location.state || {};

  if (localStorage.getItem("businessid") === null) {
    return <Redirect to="/login" />;
    //   return exit(1);
  } else {
  }

  const event_id = eventid;
  const event_name = eventname;

  return (
    <div className="view mt-5">
      <Header />
      <div className="containe pl-1 pr-1">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-12 mt-5 mb-4">
            {is_sponsorship == true ? (
              <div
                className="sponsored-badge w-100 p-2 text-center"
                style={{ fontSize: 16 }}
              >
                🌟 Tickets to this event are proudly sponsored by Karamale.
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-12">
            <div className="col-12 mb-2 text-right">
              <span className="cursor-pointer" onClick={() => history.goBack()}>
                <IoIosArrowBack size={25} /> Back
              </span>
            </div>
            <div className=" BoxDashboardContainer mb-4 pb-3  pl-3 pr-3">
              <div className="row justify-content-center w-100">
                <label className="mb-3 text-left w-100">
                  <h5>{event_name}</h5>
                </label>

                <div className="col-12 p-0">
                  <RefundRules eventid={event_id} />
                </div>
                <div className="col-12 p-0">
                  <RefundRequests eventid={event_id} />
                </div>
                {/* <div className="col-lg-6 p-1">
                    <Breakdown eventid={event_id} />
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundView;
